const MixpanelService = {
  // Pass `source` in properties to identify the exact element that fired the event,
  // e.g. track("esp_x", { source: "column_mapping_attach_button" }).
  track: (event, properties = {}) => {
    if (import.meta.env.DEV || !event) return;

    return fetch(`/api/event/track`, {
      method: "POST",
      // Use keepalive to ensure analytics are delivered even if the page is unloaded during navigation.
      keepalive: true,
      body: JSON.stringify({ event, properties }),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
      },
    });
  },
};

export default MixpanelService;
